"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var baseMapMenu = (0, _emotion.css)("\n  padding: 10px;\n  z-index: 2;\n  font-family: \"Roboto Condensed\", sans-serif;\n");

var SandboxBaseMapSelector = function SandboxBaseMapSelector(_ref) {
  var onBaseMapStyleChange = _ref.onBaseMapStyleChange,
      baseMapStyle = _ref.baseMapStyle;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("div", {
    className: baseMapMenu
  }, _react["default"].createElement("input", {
    checked: baseMapStyle === "light",
    type: "radio",
    value: "light",
    onChange: onBaseMapStyleChange
  }), _react["default"].createElement("label", {
    htmlFor: "light"
  }, "Light"), _react["default"].createElement("input", {
    checked: baseMapStyle === "dark",
    type: "radio",
    value: "dark",
    onChange: onBaseMapStyleChange
  }), _react["default"].createElement("label", {
    htmlFor: "dark"
  }, "Dark")));
};

SandboxBaseMapSelector.propTypes = {
  onBaseMapStyleChange: _propTypes["default"].func.isRequired,
  baseMapStyle: _propTypes["default"].string.isRequired
};
var _default = SandboxBaseMapSelector;
exports["default"] = _default;